import { breakpoints, breakpointsCross, breakpointsNoUnit } from './breakpoints'
import { palette } from './palette'
import { pxToRem, spacing } from './sizing'
import { typography } from './typography'
import { zIndex } from './zIndex'

export * from './breakpoints'
export * from './palette'
export * from './sizing'
export * from './typography'
export * from './zIndex'

export const analyticsPadding = '1.5vw 0'

export const buttonBorderRadius = '8px'
export const borderRadiusPreHome = '16px'
export const DigitalEventsBoxBorderRadius = '10px'

export const discontinuedOpacity = 0.4

export const footerHeight = '5vh'
export const footerMinHeight = '3.5em'

export const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195,
}

export const plpSidebarTabletLateralPadding = `${pxToRem(spacing(3))}rem`

// provided to styled-components through ThemeProvider, available as `props.theme`
export const theme = {
  palette,
  typography,
  breakpoints,
  breakpointsNoUnit,
  breakpointsCross,
  zIndex,
  duration,
}

export type Theme = typeof theme
